import * as S from './style';
import { mypageMenuList } from '@/constants/menu';
import { useNavigate } from 'react-router-dom';
import uuid from 'react-uuid';
import CloseIcon from '@/components/Icon/CloseIcon';
import ArrowRightIcon from '@/components/Icon/ArrowRightIcon';
import { useLogoutApi } from '@/api/auth';
import { useAuthStore } from '@/store/authStore';
interface MobileMenuProps {
	isOpen: boolean;
	onClickIsOpen: (isOpen: boolean) => void;
}
const MypageMobileMenu = ({ isOpen, onClickIsOpen }: MobileMenuProps) => {
	const navigate = useNavigate();
	const { name } = useAuthStore();
	const { mutateAsync: logout } = useLogoutApi();
	const onClickMenu = (menu: string) => {
		document.body.classList.remove('hidden');
		navigate('/mypage', {
			state: {
				menu: menu,
			},
		});
		onClickIsOpen(false);
	};
	const handleLogout = async () => {
		const res = await logout();
		if (res.data.success) {
			document.body.classList.remove('hidden');
			onClickIsOpen(false);
		}
	};
	return (
		<S.ModalOverlay isOpen={isOpen}>
			<S.ModalHeader>
				<S.CloseButtonBox onClick={() => onClickIsOpen(false)}>
					<CloseIcon width="40" height="40" iconColor="#fff" />
				</S.CloseButtonBox>

				<S.TitleBox>
					<p className="title">
						<strong>{name}</strong> 님
					</p>
					<S.LogoutButton type="button" onClick={handleLogout}>
						로그아웃
						<ArrowRightIcon iconColor="#fff" width="16" height="16" />
					</S.LogoutButton>
				</S.TitleBox>
			</S.ModalHeader>
			<S.ModalContent>
				{mypageMenuList.map((menu) => (
					<S.MainMenu key={uuid()} onClick={() => onClickMenu(menu.menu)}>
						{menu.menu}
					</S.MainMenu>
				))}
			</S.ModalContent>
		</S.ModalOverlay>
	);
};
export default MypageMobileMenu;
